import {
  MANAGE_LEAVE_BALANCE_REQUEST,
  MANAGE_LEAVE_BALANCE_REQUEST_ERROR,
  MANAGE_LEAVE_BALANCE_REQUEST_SUCCESS,
} from '../actionType/type';

export const manageLeaveBalanceRequest = params => {
  return {
    type: MANAGE_LEAVE_BALANCE_REQUEST,
    params: params,
  };
};

export const manageLeaveBalanceSuccess = result => {
  return {
    type: MANAGE_LEAVE_BALANCE_REQUEST_SUCCESS,
    payload: result,
    error: null,
  };
};

export const manageLeaveBalanceError = error => {
  return {
    type: MANAGE_LEAVE_BALANCE_REQUEST_ERROR,
    error: error,
    payload: null,
  };
};
